import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconGenderMale: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconGenderMale"><Circle cx="9" cy="15" r="6" stroke="currentColor"/><Path d="M14.5 3.5H20.5V9.5" stroke="currentColor" strokeLinecap="square"/><Path d="M13.25 10.75L20 4" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconGenderMale;
